import './index.less'

export default class PhotovolaticFindOut {
    constructor({ pcEl, mbEl, pcDOM, mbDOM }) {
      this.PCDOM = pcDOM || document.querySelector(pcEl)
      this.MBDOM = mbDOM || document.querySelector(mbEl)

      if (this.PCDOM && this.MBDOM) {
        const { size, videoSize, } = this.PCDOM.dataset
        this.size = size
        this.videoSize = videoSize

        this.init()

        this.init = this.init.bind(this)
        window.addEventListener('resize', this.init)
      }
    }
    init() {
      const clientWidth = document.documentElement.clientWidth || document.body.clientWidth
      if (clientWidth < 1024) {
          this.MBDOM.classList.remove('hidden')
          this.PCDOM.classList.add('hidden')

          if (this.size <= 1) {
            this.registerClickEvent(this.MBDOM)
          }

          if (!this.swiperMB && this.size > 1) {
            this.MBDOM && this.initMB();
          }

          // resize 时清除
          this.swiperPC?.destroy();
          this.swiperPC = null;
      } else {
          this.MBDOM.classList.add('hidden')
          this.PCDOM.classList.remove('hidden')

          if (this.size <= 5) {
            this.registerClickEvent(this.PCDOM)
          }

          if (!this.swiperPC && (this.videoSize === 'video_large' || this.size > 5)) {
            this.PCDOM && this.initPC();
          }

          // resize 时清除
          this.swiperMB?.destroy();
          this.swiperMB = null;
      }
    }
    initPC() {
        const self = this
        this.swiperPC = new Swiper(this.PCDOM, {
            slidesPerView: 'auto',
            spaceBetween: 12,
            centeredSlides: true,
            loop: true,
            navigation: {
                nextEl: this.PCDOM.parentElement.querySelector('.swiper-findout-pc-button-next'),
                prevEl: this.PCDOM.parentElement.querySelector('.swiper-findout-pc-button-prev'),
            },
            on: {
                init: function() {
                    self.registerClickEvent(self.PCDOM)
                },
            }
        });
    }
    renderMediaDom({ videoSrc, controls, loop }) {
        const type= videoSrc.includes('youtube.com') ? 'youtube' : 'mp4'

        let youtube_id = ''
        let youtube_embed = ''

        if (type === "youtube") {
            if(videoSrc.indexOf("/embed/") !== -1) {
                youtube_id = videoSrc.replace("https://www.youtube.com/embed/", "");
            } else {
                youtube_id = videoSrc.replace("https://www.youtube.com/watch?v=", "");
            }
            youtube_embed = `https://www.youtube.com/embed/${youtube_id}`;
        }

        let media_dom = ''
        switch (type) {
            case 'mp4':
                media_dom = `
                    <video
                        class="jky-video_media"
                        x5-video-player-type="h5-page"
                        webkit-playsinline="playsinline"
                        playsinline="playsinline"
                        autoplay="autoplay"
                        muted="muted"
                        ${controls === 'true' || controls === true ? 'controls="controls"' : ''}
                        preload="metadata"
                        ${loop === 'true' || loop === true ? 'loop' : ''} "&width=1500"
                    >
                        <source src="${videoSrc}" type="video/mp4">
                    </video>
                `
                break;
            case 'youtube':
                media_dom = `
                    <iframe
                        class="jky-video_media jky-media_youtube rounded-24"
                        src="${youtube_embed}?enablejsapi=1&autoplay=1&${loop === 'true'|| loop === true ? 'loop=1':''}&playlist=${youtube_id}&mute=1"
                        class="js-youtube global-settings-popup"
                        allow="''; encrypted-media"
                        allowfullscreen=""
                    ></iframe>
                `
            default:
                break;
        }
        return media_dom
    }
    initMB() {
        const self = this
        this.swiperMB = new Swiper(this.MBDOM, {
            slidesPerView: self.videoSize === 'video_large' ? 1 : 'auto',
            spaceBetween: 12,
            loop: true,
            navigation: {
                nextEl: this.MBDOM.parentElement.querySelector('.swiper-findout-mb-button-next'),
                prevEl: this.MBDOM.parentElement.querySelector('.swiper-findout-mb-button-prev'),
            },
            on: {
                init: function() {
                    self.registerClickEvent(self.MBDOM)
                }
            }
        });
    }
    // 注册点击事件
    registerClickEvent(DOM) {
        DOM.querySelectorAll('.swiper-slide').forEach((item, index) => {
            item.onclick = () => {
                const { videoSrc, controls, loop, index, sectionTitle, } = item.dataset
                const popupHtml = this.renderMediaDom({ videoSrc, controls, loop })

                window.ZModle.getInstance(popupHtml, {
                    id: `photovolatic-find-out-popup-mb-${index}`,
                    class: "photovolatic-find-out-popup-warp",
                    cb: () => {

                    }
                })

                // 数据埋码(公共组件为activity时候是活动页的埋码，否则属于原本)
                if ($('.section-photovolatic-find-out').parent().attr('class').includes('activity')) {
                    this.GAEvent("activity_page_user_clicks",{
                        module: 'Video Display',
                        position: $('.section-photovolatic-find-out .video-title').data('videotitle'),
                        link: videoSrc,
                    })
                }else{
                    this.GAEvent("photovoltaics_user_clicks",{
                        module: sectionTitle,
                        button_name: Number(index) + 1,
                        link: videoSrc,
                    })
                }
            }
        })
    }

    // 数据埋码
    GAEvent(eventName,params) {
        window.dataLayer.push({ "event_parameters": null });
        window.dataLayer.push({
            "event":"ga4Event",
            "event_name":eventName,
            "event_parameters":{
                "current_page": window.location.href, // current page url
                ...params
            }
        });
    }
}
